// IssueCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';

const IssueCard = ({ issue, onDelete, onUpdate, compact = false }) => {
  const navigate = useNavigate();

  // Debug: log the issue prop to see if it's updating
  console.log('IssueCard received:', issue.id, issue.type, issue.status);

  if (compact) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
        <div className="flex justify-between items-start mb-2">
          <h4 className="font-medium text-gray-900 dark:text-white text-sm">
            {issue.issueKey}
          </h4>
          <span className={`px-2 py-1 text-xs rounded-full ${
            issue.status === 'todo' ? 'bg-gray-100 text-gray-800' :
            issue.status === 'in-progress' ? 'bg-blue-100 text-blue-800' :
            issue.status === 'in-review' ? 'bg-yellow-100 text-yellow-800' :
            'bg-green-100 text-green-800'
          }`}>
            {issue.status}
          </span>
        </div>
        <p className="text-gray-600 dark:text-gray-400 text-sm mb-2 line-clamp-2">
          {issue.title}
        </p>
        <div className="flex justify-between items-center text-xs text-gray-500 dark:text-gray-400">
          <span className="capitalize">{issue.type}</span>
          <span>{issue.priority}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 lg:p-6">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            {issue.issueKey}: {issue.title}
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            {issue.description || 'No description provided.'}
          </p>
        </div>
        <span className={`ml-4 px-3 py-1 text-sm font-medium rounded-full ${
          issue.status === 'todo' ? 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300' :
          issue.status === 'in-progress' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300' :
          issue.status === 'in-review' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300' :
          'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
        }`}>
          {issue.status.replace('-', ' ')}
        </span>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-sm mb-4">
        <div>
          <span className="font-medium text-gray-500 dark:text-gray-400">Type:</span>
          <span className="ml-2 text-gray-900 dark:text-white capitalize">
            {issue.type}
          </span>
        </div>
        <div>
          <span className="font-medium text-gray-500 dark:text-gray-400">Priority:</span>
          <span className={`ml-2 px-2 py-1 text-xs font-medium rounded-full ${
            issue.priority === 'low' ? 'bg-green-100 text-green-800' :
            issue.priority === 'medium' ? 'bg-yellow-100 text-yellow-800' :
            issue.priority === 'high' ? 'bg-orange-100 text-orange-800' :
            'bg-red-100 text-red-800'
          }`}>
            {issue.priority}
          </span>
        </div>
        <div>
          <span className="font-medium text-gray-500 dark:text-gray-400">Assignee:</span>
          <span className="ml-2 text-gray-900 dark:text-white">
            {issue.assigneeName || 'Unassigned'}
          </span>
        </div>
        <div>
          <span className="font-medium text-gray-500 dark:text-gray-400">Created:</span>
          <span className="ml-2 text-gray-900 dark:text-white">
            {new Date(issue.createdAt).toLocaleDateString()}
          </span>
        </div>
      </div>

      <div className="flex space-x-2">
        <Button
          variant="outline"
          size="small"
          onClick={() => navigate(`/issues/${issue.id}`)}
        >
          View Details
        </Button>
        <Button
          variant="danger"
          size="small"
          onClick={() => onDelete(issue.id)}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default IssueCard;